import { render } from "./StagesView.vue?vue&type=template&id=57d9b887&scoped=true"
import script from "./StagesView.vue?vue&type=script&lang=js"
export * from "./StagesView.vue?vue&type=script&lang=js"

import "./StagesView.vue?vue&type=style&index=0&id=57d9b887&scoped=true&lang=css"

import exportComponent from "/builds/it60371727/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d9b887"]])

export default __exports__